namespace GeniuzPOS.QRreport {
    export interface QRyStockcardForm {
        DateEnd: Serenity.DateEditor;
        PostSequenceFg: Serenity.IntegerEditor;
        SumWhsFg: Serenity.RadioButtonEditor;
        WhsFg: Serenity.RadioButtonEditor;
        WhsId: Serenity.LookupEditor;
        ShopId: Serenity.LookupEditor;
        ListFg: Serenity.RadioButtonEditor;
        SkuCode: Serenity.LookupEditor;
        PluCode: Serenity.LookupEditor;
    }

    export class QRyStockcardForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRyStockcard';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRyStockcardForm.init)  {
                QRyStockcardForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.RadioButtonEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(QRyStockcardForm, [
                    'DateEnd', w0,
                    'PostSequenceFg', w1,
                    'SumWhsFg', w2,
                    'WhsFg', w2,
                    'WhsId', w3,
                    'ShopId', w3,
                    'ListFg', w2,
                    'SkuCode', w3,
                    'PluCode', w3
                ]);
            }
        }
    }
}
